<div class="enhance-item  container" [ngClass]="direction == 'left' ? '' : 'reverse'">
  <div class="enhance-image">
    <img src="{{image}}" />
  </div>

  <div class="enhance-description-container">
    <h2>{{title}}</h2>
    <p>{{subtitle}}</p>
  </div>
</div>
